












































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Button, Icon } from '@alpha/ink'
import ListItem from '@/components/ListItem.vue'
import FilterBar from '@/components/FilterBar.vue'
import * as ui from '@/types/frontend'
import Audience from './Audience'

export interface AudienceGroup {
  title: string,
  description: string
  audiences: Audience[]
}

@Component({
  components: {
    Button,
    ListItem,
    FilterBar,
    Icon
  }
})

export default class AudienceSelectionSidebar extends Vue {
  @Prop({ required: true }) readonly audienceGroups!: AudienceGroup[]
  @Prop({ required: true }) readonly searchFilter!: ui.Filter<{}>
  @Prop({ default: null }) readonly selectedAudienceId!: string | null
}
